module.exports = __webpack_public_path__ + "static/media/blogs-3.e496cbf0.jpg";